import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    {name:"Tag Type",prop:"tagcategories_ids"},
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  

  tag_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  selected_tag_cat_id = null
  isTagCat : boolean =false

  guideline_data:any
  activePage = 1
  statusList =[
    {name:'Pending',id:'pending'},
    {name:'Approved',id:'approved'},
    {name:'Not Approved',id:'not-approved'}

  ]
  activeTab='pending'
  activeTabName='Pending'
  fileData: File
  performer_list=[
    {name:'Yes',_id:'yes'},	
    {name:'No',_id:'no'},	

  ]
  selected_performer=null
  learningModeId='631ad8abce5c666542591bd9'
  enrollment_status=[
    {name:'Pending' , _id:'pending'},
    {name:'Completed' , _id:'completed'}
  ]
  constructor( public apiService:ApiService,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService,
               private route: Router,private activerouter:ActivatedRoute) { 
              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key == 'Tags')
              this.guideline_data = key_data[0]?._id
                }

  ngOnInit() {
    this.getModeTagByCategory()
    this.activeOnboardingTab('Pending','pending')
  }
  getModeTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.learningModeId).subscribe((res:any)=>{
      let learningmode = res?.data[0]
      let learningmode1 = res?.data[1]

      this.enrollment_status.push(learningmode,learningmode1)
      const desiredStatusOrder = ['Pending','Classroom','Online','Completed'];
      this.enrollment_status.sort((a, b) => {
        const aIndex = desiredStatusOrder.indexOf(a.name);
        const bIndex = desiredStatusOrder.indexOf(b.name);
        return aIndex - bIndex;
      });
    })
  }
  activeOnboardingTab(tabName,id) {
    const activetab = id;
    this.activeTab = id
    this.activeTabName = tabName
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activerouter, queryParams: { status: tabName } }
      );
      this.setAndGetOnboardingbyStatus()
    }
  }
  setAndGetOnboardingbyStatus() {
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTabName = params?.status;
        
        switch (this.activeTabName) {
          case 'Pending':
            this.getAllOnboarding(this.activeTabName);
            break;
            case 'Classroom':
              this.getAllOnboarding(this.activeTabName);
              break;
            case 'Online':
              this.getAllOnboarding(this.activeTabName);
              break;
              case 'Completed':
            this.getAllOnboarding(this.activeTabName);
            break
        }
      })
  }
  getAllOnboarding(status){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      if(status === 'Classroom'){
        this.apiService.getAllOnboarding(this.selected_performer || '','6325cd99bc4b543c7a24298f',this.activePage, this.limitRef).subscribe((res: any) => {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
          
        })
      }
      if(status === 'Online'){
        this.apiService.getAllOnboarding(this.selected_performer || '','6325cdb2bc4b543c7a242996',this.activePage, this.limitRef).subscribe((res: any) => {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
          
        })
      }
     
      if(status === 'Pending'){
        this.apiService.getAllOnboarding(this.selected_performer || '',this.activeTab,this.activePage, this.limitRef).subscribe((res: any) => {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
          
        })
      }
      if(status === 'Completed'){
        this.apiService.getAllOnboarding(this.selected_performer || '',this.activeTab,this.activePage, this.limitRef).subscribe((res: any) => {
          this.spinner.hide();
          this.rows = res?.data?.items
          this.page.totalPages = res?.data?.totalCount
          
        })
      }
    
  }

  pageChangeData(page:any){
    this.apiService.getTagsList(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.rows=res.data.items
      this.page.totalPages=res.data.totalCount
  
    })
  }
  
  deleteTag(){
    if(this.tag_id){
      this.apiService.tagDelete(this.tag_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }
   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.tag_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteTag()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
 
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  updateStatus(id, status_id) {
    let formData = new FormData();
    formData.append('status',status_id)
    if (id) {
      this.apiService.updateOnboarding(id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('status update successfully')
          this.setAndGetOnboardingbyStatus()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  filter(data){
    this.apiService.getFilterOnboarding(data).subscribe((res:any)=>{
      if(res?.statusCode ===200){
        this.rows = res?.data
      this.page.totalPages = res?.data.length
      }
    })
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.setAndGetOnboardingbyStatus()
  }
  getPerformerId(event){
    this.selected_performer
    this.setAndGetOnboardingbyStatus()
  }
  gotoLink(url){
    this.validateLinkedInURL(url)
  }
validateLinkedInURL(url) {
  const linkedInPattern = /^https?:\/\/(www\.)?linkedin\.com\/(in|pub|company)\/[a-zA-Z0-9-_%]+/;
  
  try {
      // Prepend https:// if missing
      if (!url.startsWith('http')) {
          url = 'https://' + url;
      }

      const urlObj = new URL(url);
      const cleanURL = urlObj.origin + urlObj.pathname; // Removing query parameters

      if (linkedInPattern.test(cleanURL)) {
          window.open(cleanURL, '_blank');
          return true;
      } else {
          this.toastr.error("Invalid LinkedIn URL. Please enter a correct LinkedIn profile URL.");
          return false;
      }
  } catch (error) {
      this.toastr.error("Invalid URL format.");
      return false;
  }
}
}

